module.exports = __webpack_public_path__ + "media/AUDIO 11.a1a15a95.mp3";